export const ALERT_SOCKET_NAMESPACE = "alerts";

export const ALERT_SOCKET_EVENTS = {
    TRIGGER_REQUEST: "alert:trigger:request",
    TRIGGERED_RESPONSE: "alert:triggered:response",
} as const;

export type AlertType = "confetti" | "clear_local_storage";

export type AlertSocketEvents = {
    [ALERT_SOCKET_EVENTS.TRIGGER_REQUEST]: { targetUserId: string; alertType: AlertType };
    [ALERT_SOCKET_EVENTS.TRIGGERED_RESPONSE]: AlertType;
};
